import React from "react"
import { Box } from "@mui/material"
import {
  AnnouncementsItemType,
  FeedbackSurvey
} from "../../../../mp-database/contextHelpManager"
import {
  GhostieHeader,
  GhostieContent,
  GhostiePagination,
  LearnMoreModal
} from "./components"
import { GhostieType, useStyles } from "./styles"

interface Props {
  data: AnnouncementsItemType[]
  selectedItem: AnnouncementsItemType
  currentPage: number
  totalPages: number
  type?: string
  isCardOpen: boolean
  isCardHidden: boolean
  isLearnMoreOpen: boolean
  isLoadingItem?: (itemId: string) => boolean
  onOpenClose: () => void
  submitCardHandler: (item: AnnouncementsItemType) => void
  onClickCustomButton?: () => void
  learnMoreModalHandler?: (item?: AnnouncementsItemType) => void
  onSendFeedbackClick?: (fb: FeedbackSurvey) => void
  onChangePage: (nextPage: number) => void
}

const GhostieCard = React.forwardRef<any, Props>(
  (
    {
      data,
      selectedItem,
      currentPage,
      totalPages,
      type = "general",
      isCardOpen,
      isCardHidden,
      isLearnMoreOpen,
      isLoadingItem,
      onOpenClose,
      submitCardHandler,
      learnMoreModalHandler,
      onSendFeedbackClick,
      onClickCustomButton,
      onChangePage
    },
    ref
  ) => {
    const { classes } = useStyles({
      type: type as GhostieType,
      isCardOpen,
      isCardHidden
    })

    return (
      <>
        <Box ref={ref} className={classes.cardContainer}>
          <GhostieHeader
            isCardOpen={isCardOpen}
            type={type}
            classes={classes}
            onOpenClose={onOpenClose}
          />

          <Box
            className={classes.cardContentContainer}
            aria-hidden={!isCardOpen}
            {...(!isCardOpen && { inert: "" })}
          >
            <GhostieContent
              data={data}
              currentPage={currentPage}
              classes={classes}
              isLoadingItem={isLoadingItem}
              submitCardHandler={submitCardHandler}
              onOpenClose={onOpenClose}
              onClickCustomButton={onClickCustomButton}
              learnMoreModalHandler={learnMoreModalHandler}
              onSendFeedbackClick={onSendFeedbackClick}
            />

            <GhostiePagination
              classes={classes}
              totalPages={totalPages}
              currentPage={currentPage}
              onChangePage={onChangePage}
            />
          </Box>
        </Box>

        <LearnMoreModal
          selectedItem={selectedItem}
          open={isLearnMoreOpen}
          onClose={learnMoreModalHandler}
        />
      </>
    )
  }
)

export default GhostieCard
